import React from 'react';
import { findFilenames } from '../../services/API';
import WordInterventionModal from '../WordInterventionModal';
import pronounce_icon from "../../images/intervention_icons/pronounce.svg";
import { COPY_STRINGS } from '../../constants/translatedCopy';
import {getUserData} from '../../services/API';
import {logSessionInfo} from '../../services/logger';
import { shouldSoundOutPhonemes, withLanguageSelection } from '../../services/InterventionUtils';
import { spellAndSayTheWord, spellAndSayTheWordBilingual } from '../../services/interventionSpeeches';

export default class PhonemeGiveWord extends React.Component {
  constructor(props) {
    super(props);

    this.mounted;
    this.speakPhonemes = this.speakPhonemes.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
    this.props.handleMessage({
      speakFunction: this.speakPhonemes,
      callback: () => this.props.handleMessage({continueWithoutSpeaking: true, endOfPhrase: this.props.endOfPhrase}),
    });
  }

  componentWillUnmount() {
    this.props.speech.isSpeaking && this.props.speech.abortSpeech();
    this.mounted = false;
  }

  speakPhonemes(onEnd) {
    const { inWord, speech } = this.props;
    const { metadata } = this.props.chosenIntervention;

    if(!metadata || !metadata.PHON){
      logSessionInfo("skipping_speaking_phonemes",{inWord: inWord, metadata: metadata});
      if(onEnd){
        onEnd();
      }
    }

    const cleanWord = inWord.replace(/[.,\/#!$%\^&\*;:{}=\_`'~()""?!]/g, "")
    const filenames = findFilenames(metadata.PHON);

    let onEndWithPhonemes;
    if(Array.isArray(filenames) && filenames.length > 0 && shouldSoundOutPhonemes(metadata)){
      onEndWithPhonemes = (inFilenames, onEnd) => {
        if(!this.mounted) {
          // stop this recursive function from running again if we're unmounting
          onEnd && onEnd();
          return;
        }
        if(inFilenames.length <= 0){//If we've played all the phonemes then add a pause and say the close speech
          if(getUserData().bilingualMode){
            speech.speak({textToSpeak: "<break time=\"0.5s\" />" + COPY_STRINGS.intervention_strings.makes, passThroughSpeechTags: true});
            speech.speak({textToSpeak: cleanWord + ":", skipTranslation: true, onEnd: onEnd});
          } else {
            speech.speak({
              textToSpeak: "<break time=\"0.5s\" />" + COPY_STRINGS.intervention_strings.makes + ": " + `"${cleanWord}".`,
              onEnd: onEnd,
              passThroughSpeechTags: true
            });
          }
          return;
        }else{
          //create the sound, and recursively play the rest of the phonemes when the current one is done.
          //IOW, call this method again in the onfinish event of the current phoneme.
          console.log('PhonemeGiveWord playing:', JSON.stringify({
            word: cleanWord,
            url: inFilenames?.length ? inFilenames[0] : undefined,
            PHON: metadata?.PHON
          }));
          speech.speakAudioFile({
            url: inFilenames[0],
            onfinish: onEndWithPhonemes.bind(null,inFilenames.slice(1),onEnd),
          });
        }
      }


      if(onEndWithPhonemes){
        speech.speak({
          textToSpeak: COPY_STRINGS.intervention_strings.imGoingToSoundThisWordOut,
          onEnd: () => onEndWithPhonemes(filenames, onEnd),
        });
      }

    }else{
      // by rule, don't sound out each phoneme, just spell and say the word instead.
      withLanguageSelection({
        bilingual: () => spellAndSayTheWordBilingual(speech, cleanWord, onEnd),
        english: () => spellAndSayTheWord(speech, cleanWord, onEnd)
      })
    }
  }

  render() {
    const { inWord, chosenIntervention } = this.props;

    let wordToDisplay;
    if(inWord.includes("'"))
      wordToDisplay = inWord.split('').join(' ');
    else
      wordToDisplay = (chosenIntervention.metadata && chosenIntervention.metadata.GRAPHEMIC_BREAKDOWN)
      ? chosenIntervention.metadata.GRAPHEMIC_BREAKDOWN.split('/').join(' ')
      : inWord.split('').join(' ');

    return (
      <WordInterventionModal
        word={wordToDisplay}
        icon={pronounce_icon}
        useWordIcon={true}
        instructions={COPY_STRINGS.intervention_strings.the_word_is_capitalized}
        showListeningStatus={false}
      />
    )
  }
}